export default __webpack_public_path__ + "static/project-slide-1-1248-765-ffaf0d1dad06b487c0bc6b21533ade23.webp";